import * as React from 'react';

export default function Direction({...rest}) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="24px/direction">
        <g id="24x24_direction">
          <path
            id="Shape"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.82 6.11999C21.3449 4.82806 22.6055 3.98765 24 3.99999C25.4 3.985 26.6678 4.82491 27.2 6.11999L41.62 39.18C42.066 40.2489 41.951 41.4697 41.3131 42.4366C40.6753 43.4034 39.5982 43.9895 38.44 44C37.9577 43.997 37.4812 43.8949 37.04 43.7L25.26 36.94C24.8649 36.7575 24.4352 36.6621 24 36.66C23.5651 36.6645 23.1359 36.7599 22.74 36.94L10.96 43.7C10.5188 43.8949 10.0423 43.997 9.55998 44C8.40175 43.9895 7.32467 43.4034 6.68681 42.4366C6.04895 41.4697 5.93393 40.2489 6.37998 39.18L20.82 6.11999ZM24.76 7.17999C24.6469 6.85966 24.3395 6.64933 24 6.65999C23.6762 6.64585 23.3791 6.83858 23.26 7.13999L8.89998 40.22C8.78613 40.4394 8.78613 40.7006 8.89998 40.92C9.05094 41.1402 9.29372 41.28 9.55998 41.3H9.79998L21.74 34.54C23.2218 33.8735 24.9181 33.8735 26.4 34.54L38.26 41.34H38.5C38.7662 41.32 39.009 41.1802 39.16 40.96C39.2882 40.73 39.2882 40.45 39.16 40.22L24.76 7.17999Z"
            fill="#001E50"
          />
        </g>
      </g>
    </svg>
  );
}
